export default __webpack_public_path__ + "static/media/vitra_chair_06.6d4119b5.jpg";